import axiosInst from 'api/axios';

export const getPdf = (link, name, setLoading, id) => {
  axiosInst()
    .get(link, { responseType: 'arraybuffer' })
    .then((resp) => {
      const file = new Blob([resp.data], { type: 'application/pdf' });

      file.name = name;

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(file, name);
      } else if (window.navigator.userAgent.match(/Chrome/i) && window.navigator.userAgent.match(/Mobile/i)) {
        window.open(
          `${process.env.REACT_APP_API}/accounts/pdf/${id}?Authorization=Bearer ${localStorage.getItem('token')}`,
        );
      } else if (window.navigator.userAgent.match('CriOS')) {
        const reader = new FileReader();
        reader.onloadend = function () {
          window.open(reader.result);
        };
        reader.readAsDataURL(file);
      } else if (window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i)) {
        const url = window.URL.createObjectURL(file);
        window.location.href = url;
      } else {
        const url = window.URL || window.webkitURL;
        window.open(url.createObjectURL(file));
      }
    })
    .catch((e) => {
      console.log(e);
    })
    .finally(() => {
      setLoading && setLoading(false);
    });
};

export const getPack = (link, name) => {
  axiosInst()
    .get(link, { responseType: 'arraybuffer' })
    .then((resp) => {
      const file = new Blob([resp.data], { type: 'application/zip' });

      file.name = name;
        const url = window.URL || window.webkitURL;
        window.open(url.createObjectURL(file));
    })
    .catch((e) => {
      console.log(e);
    });
};
